// Centralized pricing configuration for IZYPOS
export const PRICING_CONFIG = {
  // Base plan prices (monthly)
  plans: {
    counterService: {
      basePrice: 39,
      withInventoryPrice: 45,
    },
    tableService: {
      basePrice: 49,
      withInventoryPrice: 55,
    },
  },
  
  // Additional charges
  inventory: {
    monthlyCharge: 6,
    yearlyCharge: 72, // 6 * 12
  },
  
  // Setup and device fees
  setup: {
    oneTimeFee: 225,
  },
  
  devices: {
    additionalDeviceFee: 9,
    freeDevices: 5,
  },
  
  // Annual plan multiplier (10 months instead of 12)
  annualMultiplier: 11,
  calculateAnnualPriceForTS: 11,
  annualMultiplierTSWithInventory: 10,
} as const;

// Helper functions for price calculations
export const calculateAnnualPrice = (monthlyPrice: number): number => {
  return monthlyPrice * PRICING_CONFIG.annualMultiplier;
};

export const calculateAnnualPriceForTS = (monthlyPrice: number): number => {
  return monthlyPrice * PRICING_CONFIG.annualMultiplier;
};

export const calculateAnnualPriceForTSFor10Months = (monthlyPrice: number): number => {
  return monthlyPrice * PRICING_CONFIG.annualMultiplierTSWithInventory;
};

export const calculateAnnualPriceForTSWithInventory = (monthlyPrice: number): number => {
  const annualBasePrice = calculateAnnualPriceForTSFor10Months(monthlyPrice);
  return annualBasePrice + PRICING_CONFIG.inventory.yearlyCharge + 37;
};

export const calculateAnnualWithInventoryPrice = (monthlyPrice: number): number => {
  const annualBasePrice = calculateAnnualPrice(monthlyPrice);
  return annualBasePrice + PRICING_CONFIG.inventory.yearlyCharge - 2;
};

export const calculateDeviceCost = (extraDevices: number, isAnnual: boolean = false): number => {
  const deviceFee = PRICING_CONFIG.devices.additionalDeviceFee;
  const months = isAnnual ? 12 : 1;
  return Math.max(0, extraDevices) * deviceFee * months;
};

// Plan constants for easy reference
export const PLAN_TYPES = {
  COUNTER_SERVICE: 'CS',
  TABLE_SERVICE: 'TS',
  COUNTER_SERVICE_WITH_INVENTORY: 'CS_WITH_INVENTORY',
  TABLE_SERVICE_WITH_INVENTORY: 'TS_WITH_INVENTORY',
} as const;

// Helper function to get inventory charge strings
export const getInventoryChargeStrings = () => ({
  monthly: `+$${PRICING_CONFIG.inventory.monthlyCharge} per month`,
  yearly: `+$${PRICING_CONFIG.inventory.yearlyCharge} per year`,
}); 